import Box from '@mui/material/Box';
import { SearchField } from '@openx/design-system/components/SearchField/SearchField.tsx';
import { useTranslation } from 'react-i18next';
import { OpenXAgentSelect } from '../../shared/OpenXAgentSelect.tsx';
import { ALL_DATA_PARTNERS } from '../utils/consts.ts';

type MatchedSegmentToolbarProps = {
  searchQuery: string;
  onSearchQueryChange: (query: string) => void;
  dataPartner: string;
  dataPartners: string[];
  onDataPartnerChange: (dataPartner: string) => void;
};

export const MatchedSegmentToolbar = ({
  searchQuery,
  onSearchQueryChange,
  dataPartner,
  dataPartners,
  onDataPartnerChange,
}: MatchedSegmentToolbarProps) => {
  const { t } = useTranslation();

  return (
    <Box sx={{ display: 'flex', gap: 1, mt: 1.5 }}>
      <SearchField
        value={searchQuery}
        onChange={event => onSearchQueryChange(event.target.value)}
        placeholder={t('Search')}
        inputLabel={t('Search segments')}
        slotProps={{ htmlInput: { 'data-test': 'openx-agent-matched-segment-search' } }}
        sx={{ flex: '0 1 240px', minWidth: 120 }}
      />

      <OpenXAgentSelect
        value={dataPartner}
        onChange={onDataPartnerChange}
        ariaLabel={t('Data partner')}
        dataTest="openx-agent-matched-segment-data-partner"
        placeholder={t('Data Partner')}
        options={[
          { value: ALL_DATA_PARTNERS, label: t('All Data Partners') },
          ...dataPartners.map(name => ({ value: name, label: name })),
        ]}
      />
    </Box>
  );
};
